/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { ROUTES } from '@constants/routes';
import { generateUrl } from '@routes/util';
import { useParams } from 'react-router-dom';
import { CrossLinkCard, IntegrationsDashboard } from '@features/integrations';
import { MTAdminBreadcrumbs } from '../components/breadcrumbs/MTAdminBreadcrumbs';
import config from '../../../config';
import { companyTrackerCardConfig } from '@constants/app-card';
import { createOnClickFromExternalUrl } from '@utils/click-handler';

export const IntegrationsRoute = () => {
  const { initiativeId } = useParams<{ initiativeId: string }>();

  const companyTrackerCard: CrossLinkCard = {
    key: 'company-tracker',
    logo: companyTrackerCardConfig.logo,
    color: companyTrackerCardConfig.color,
    name: 'Company Tracker',
    description: 'Manage sustainability data collection across your organisation.',
    learnMoreUrl: config.brochureURL.companyTracker,
    section: 'connected',
    onOpen: createOnClickFromExternalUrl(generateUrl(ROUTES.COMPANY_TRACKER, { initiativeId })),
  };

  return (
    <IntegrationsDashboard
      initiativeId={initiativeId}
      crossLinkCards={[companyTrackerCard]}
      BreadCrumbsComponent={MTAdminBreadcrumbs}
    />
  );
};
